export const Logo = require('./logo.png');
export const Taxi = require('./taxi.png');
export const Reporte = require('./analitica.png');
export const CashBox = require('./cashier.png');
export const Increment = require('./increment.png');
export const Person = require('./person.png');
export const Huella1 = require('./Huella1N.png');
export const Huella2 = require('./Huella2N.png');
export const AsistenciaR = require('./HuellaB.png');
export const AsistenciaRP = require('./HuellaBR.png');
